import { __assign } from "tslib";
/** BiData that does not allow contextual data, use this outside of components */
export function PureBiData(data) {
    return __assign(__assign({}, data), { _biLoggerVersion: 2 });
}
//# sourceMappingURL=base.js.map